<template>
  <div class="order-detail-box">
    <PcWorkOrderDetail v-if="false" />
    <MWorkOrderDetail />
  </div>
</template>

<script type="text/ecmascript-6">
import PcWorkOrderDetail from "./pc/WorkOrderDetail.vue";
import MWorkOrderDetail from "./m/WorkOrderDetail.vue";


export default {
  data() {
    return {
      orderForm: {},
    };
  },
  components: {
    PcWorkOrderDetail,
    MWorkOrderDetail,
  },
  created() {
    // this.handleRoute();
  },
  methods: {
    onSubmit() {},
  },
};
</script>

<style scoped lang="scss">
.order-detail-box {
  height: 100%;
}
</style>

